import {ApolloClient} from 'apollo-client';
import {InMemoryCache, defaultDataIdFromObject} from 'apollo-cache-inmemory';
import {ApolloLink} from 'apollo-link';
import {createHttpLink} from 'apollo-link-http';

const CSRF_TOKEN_HEADER = 'x-csrf-token';

export default ({prefix, siteContext}) => {
    const cache = new InMemoryCache({
        dataIdFromObject: (object) => {
            switch (object.__typename) {
                case 'Badge':
                    return object.helpText;
                default:
                    return defaultDataIdFromObject(object);
            }
        },
    }).restore();
    const linkHeaders = {
        'client-name': 'landingapp',
        'client-version': '1.0.0',
        'x-homeaway-site': `${siteContext.name}`,
    };

    const httpLink = createHttpLink({
        uri: `${prefix}/graphql`,
        credentials: 'same-origin',
        headers: linkHeaders,
    });

    const setCsrfToken = new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                // Adding `x-csrf-token` for XHR queries when users are logged in
                [CSRF_TOKEN_HEADER]: window.ha.csrfToken,
            },
        });

        return forward(operation).map((res) => {
            const {response} = operation.getContext();
            const csrfToken = response.headers.get(CSRF_TOKEN_HEADER);

            if (csrfToken) {
                window.ha.csrfToken = csrfToken;
            }

            return res;
        });
    });

    return new ApolloClient({
        ssrMode: false,
        cache,
        link: setCsrfToken.concat(httpLink),
    });
};
